<template>
  <div>
    <div class="bg-white py-4  rounded box-shadow-primary relative">
      <div
        class="correct-answer py-4 flex flex-col items-center justify-center"
        v-if="answered && acertou"
      >
        <div>
          <i class="material-icons text-green-400 text-5xl">
            check_circle_outline
          </i>
        </div>

        <span class="text-xl">Você Acertou!</span>
      </div>
      <div
        class="wrong-answer py-4 flex flex-col items-center justify-center"
        v-if="answered && !acertou"
      >
        <div>
          <i class="material-icons text-red-400 text-5xl">
            error_outline
          </i>
        </div>

        <span class="text-xl">Você errou!</span>

        <button
          class="button button-answer"
          v-if="!acertou && answered"
          @click="handleClickTryAgain"
          :class="{ active: selectedItem, acertou: acertou }"
        >
          Tentar Novamente
        </button>
      </div>
      <p class="px-2">
        <QuizPergunta
          :perguntaArray="perguntaArray"
          @placeholderClick="handleClickPlaceholder"
          :spots="spots"
        ></QuizPergunta>
      </p>

      <hr class="my-8 w-1/2 mx-auto" />

      <div>
        <div class="alternatives px-2">
          <ul class="text-center">
            <li
              v-for="(alternative, index) in scrambledAlternatives"
              @click="handleClickAlternative($event, alternative)"
              :ref="'alt' + index"
              :class="{ disabled: alternative.selected }"
              :key="`alt${index}`"
              class="box-shadow-primary"
            >
              {{ alternative.text }}
            </li>
          </ul>
        </div>
        <div class="">
          <div class="flex">
            <!-- <button
              v-if="!answered"
              @click="answerQuiz"
              class="button button-answer mt-3 px-10"
              :class="{ active: selectedItem, acertou: acertou }"
            >
              Responder
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuizPlaceholder from "./QuizPlaceholder.vue";
import QuizPergunta from "./QuizPergunta.vue";

export default {
  name: "Quiz",
  props: ["currentContent"],
  data() {
    return {
      perguntaArray: this.currentContent.quiz_question.split(" "),
      alternatives: this.currentContent.quiz_alternatives.map(alternative => {
        return {
          text: alternative,
          selected: false
        };
      }),
      spots: [],
      correctAnswersArray: [],
      acertou: false,
      answered: false
    };
  },
  mounted() {
    // Vamos Gerar o Spots array (que irá preencher os incógnitos)
    this.resetSpots();

    // Vamos Gerar o array de respostas corretas (antes de embaralhar)
    this.correctAnswersArray = this.spots.map((spot, index) => {
      return this.currentContent.quiz_alternatives[index];
    });

    // Vamos ver se já foi completo o quiz. Se já, vamos marcar as que foram respondidas antes.
    if (this.currentContent.completed) {
      let previousAnsweredAlternatives = JSON.parse(
        this.currentContent.answered_alternatives
      );

      this.spots = previousAnsweredAlternatives; // vamos marcar o array de spots
      // e também marcar como selecionadas as alternativas.
      this.alternatives = this.alternatives.map(alternative => {
        return {
          text: alternative.text,
          selected: previousAnsweredAlternatives.find(
            previous => previous === alternative.text
          )
            ? true
            : false
        };
      });
    }
  },

  computed: {
    scrambledAlternatives: function() {
      // Vamos embaralhar as alternativas.
      for (let i = this.alternatives.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [this.alternatives[i], this.alternatives[j]] = [
          this.alternatives[j],
          this.alternatives[i]
        ];
      }
      return this.alternatives;
    },
    quizPergunta: function() {
      return {
        template: `<div>${this.perguntaArrayWithComponent}</div>`,

        data() {
          return {};
        },
        name: "QuizPergunta"
      };
    },

    perguntaArrayWithComponent: function() {
      let counter = 0;
      return this.perguntaArray
        .map(item => {
          if (item == "???") {
            const itemToReplace = `<QuizPlaceholder :perguntaArray="${this.perguntaArray}" index="${counter}"></QuizPlaceholder>`;
            counter++;
            return itemToReplace;
          }
          return item;
        })
        .join(" ");
    },
    // server para mudarmos os botões.
    selectedItem: function() {
      return !this.spots.every(spot => {
        return spot == "???";
      });
    }
  },
  methods: {
    handleClickPlaceholder(e) {
      if (e.target.innerText === "???") return false; // se não tem nada, nada acontece.
      this.answered = false; // vamos resetar se estiver true.

      // Vamos achar a alternativa correspondente...
      const alternative = this.alternatives.find(alternative => {
        return alternative.text === e.target.innerText;
      });
      // ... e desmarcar a alternativa
      alternative.selected = !alternative.selected;

      // Vamos preencher com ??? no spot
      this.spots[this.spots.indexOf(e.target.innerText)] = "???";
      this.spots = [...this.spots]; //force rerender

      this.$emit("clickedPlaceholder", this.spots);
    },

    handleClickAlternative(e, alternative) {
      this.answered = false;

      if (alternative.selected) {
        this.spots[this.spots.indexOf(alternative.text)] = "???"; // Vamos substituir o texto da alternativa por ???
        this.spots = [...this.spots]; // cópia de array para rerender.
        // // Vamos marcar como (selected: false) a alternativa
        alternative.selected = !alternative.selected;
        //Vamos também desmarcar como  "respondido"

        // Se o botão NÃO tiver sido selecionado, vamos checar se ainda há espaços para selecionar (ou seja, se há algum item ??? no spots)
      } else if (!alternative.selected && this.spots.indexOf("???") !== -1) {
        this.spots[this.spots.indexOf("???")] = e.target.innerText; // Vamos substituir o spot pelo texto da alternativa.
        this.spots = [...this.spots]; // cópia de array para rerender.

        // Vamos marcar como (selected: true) a alternativa
        alternative.selected = !alternative.selected;
      }
      this.$emit("clickedAlternative", this.spots);
    },

    answerQuiz() {
      // Se nenhum item foi selecionado, não vamos fazer nada.
      if (!this.selectedItem) return;

      // Vamos marcar como respondido
      this.answered = true;

      if (
        this.spots.length === this.correctAnswersArray.length &&
        this.spots.every(
          (value, index) =>
            value.trim() === this.correctAnswersArray[index].trim()
        )
      ) {
        this.acertou = true;
      } else {
        this.acertou = false;
      }
      // vamos mandar para a API.
      this.$emit("answerQuiz", {
        answered_alternatives: this.spots,
        is_correct: this.acertou
      });
    },

    handleClickTryAgain() {
      this.answered = false;
      this.resetSpots();
      this.$emit("clickedTryAgain", this.spots);
    },
    resetSpots() {
      this.spots = this.perguntaArray.filter(item => {
        return item == "???";
      });

      this.alternatives = this.alternatives.map(alternative => {
        return {
          text: alternative.text,
          selected: false
        };
      });
    }
  },

  components: {
    QuizPlaceholder, // eslint-disable-line vue/no-unused-components
    QuizPergunta
  }
};
</script>

<style lang="scss" scoped>
p {
  font-size: 1.2rem;
  font-weight: lighter;
}

.alternatives ul {
  list-style: none;
  padding-left: 0;
}

.alternatives li {
  padding: 6px;
  border-radius: 5px;
  background-color: #c4c4c4;
  display: inline-block;
  margin-right: 5px;
  margin-bottom: 10px;
  cursor: pointer;
  border-bottom: 3px solid gray;
  color: #666;
  font-weight: normal;
}

.alternatives li:hover {
  background-color: #d1d1d1;
}

.disabled {
  background-color: #ac98cf !important;
  color: white !important;
  // opacity: 0.6;
  border-bottom: 3px solid #5f4d7c !important;
}
.wrong-answer,
.correct-answer {
  background-color: rgba(0, 0, 0, 0.7);
  margin-bottom: 15px;
  border-radius: 10px;
  color: white;
  position: absolute;
  top: 0px;
  width: 100%;
  min-height: 100%;
}

.button-answer {
  background-color: #f79b77;
  color: white;
  font-weight: bold;
  width: initial;
  margin: 15px auto;
  border-bottom: 4px solid darken(#f79b77, 10%);

  &.active {
    background-color: #f79b77 !important;
  }
}
</style>
